module.exports = __webpack_public_path__ + "media/images/recruit/description/aws-badge-8c0c5a2e6cdbe5108aa90ba811ec1a83.svg";